export default {
	tenantId: "aigIn_demo",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "aigin--demo"
	}
}
